<template>
  <div class="payment-price-row">
    <div
      v-for="transaction in data.transactionItems"
      :key="transaction.idTransactionItemInt"
    >
      {{ transaction.price | currencyTruncate }}
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "payment-price-row",
  props: {
    data: { type: Object },
  },
};
</script>
  
  <style>
.payment-price-row {
  padding-top: 7px;
}
</style>